import { intl } from 'lang/intl'
import bowser from 'bowser'
import { setFatalError } from '../../FatalError/FatalError'

declare global {
  interface Window {
    webkitRTCPeerConnection: typeof RTCPeerConnection
  }
}

const ensureBrowserSupport = () => {
  /** Confirm browser is one of */
  if (
    !(
      bowser.chrome ||
      bowser.chromium ||
      bowser.firefox ||
      bowser.safari ||
      bowser.blink
    )
  ) {
    setFatalError(
      intl.formatMessage({
        defaultMessage:
          'Your browser is not supported. Please use either Chrome, Safari, Firefox or Edge.',
        id: 'ncC911',
      })
    )
    return false
  }

  /** WebRTC tech check */
  if (!window.webkitRTCPeerConnection && !window.RTCPeerConnection) {
    setFatalError(
      intl.formatMessage({
        defaultMessage:
          'Your browser does not support WebRTC technology that enables webinars. ' +
          'Please update your browser.',
        id: 'RhiJVk',
      })
    )
    return false
  }

  return true
}

export { ensureBrowserSupport }
